import React from "react";
import Brands from "./Brands";
import Carousel from "./Carousel";
import Footer from "../Shared/Footer";
import Services from "./Services";
import Members from "./Members";

const Home = () => {
  return (
    <>
      <main>
        <Carousel></Carousel>
        <Brands></Brands>
        <Services></Services>
        <Members></Members>
      </main>
      <Footer></Footer>
    </>
  );
};

export default Home;
